import axios from 'axios'
import { api, handleApiError } from '../client'

export type ContactReason = 'sales' | 'support' | 'partnership' | 'press' | 'other'

export interface ContactFormRequest {
  name: string
  email: string
  phone: string
  company: string
  reason: ContactReason | ''
  message: string
}

export interface ContactFormResponse {
  id: string
  success: boolean
  message: string
}

/** First message from an ASP.NET ValidationProblemDetails body, if there is one. */
function firstValidationMessage(error: unknown): string | null {
  if (!axios.isAxiosError(error)) return null
  const errors = error.response?.data?.errors as Record<string, string[]> | undefined
  if (!errors) return null
  return Object.values(errors).flat()[0] ?? null
}

export const contactService = {
  /**
   * Submit the public contact form (anonymous, rate limited per IP).
   */
  async submit(data: ContactFormRequest): Promise<ContactFormResponse> {
    try {
      const response = await api.post<ContactFormResponse>('/v1/contact', data)
      return response.data
    } catch (error) {
      throw new Error(firstValidationMessage(error) ?? handleApiError(error))
    }
  },
}
